import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { CONCURSOAPI } from '../const';

const sliceName = 'actoAdministrativo';

type ActoAdministrativoProps = { nroResolucionBora: number; fresolucionBora: string };
type State = {
  data: null | ActoAdministrativoProps;
  file: string;
  success: string;
  error: string;
  loading: boolean;
};

const initialState: State = { data: null, file: '', success: '', error: '', loading: false };

type GetDatoProps = { idLlamadoConcurso: number };
export const getDatosExpediente = createAsyncThunk<ActoAdministrativoProps, GetDatoProps>(
  `${sliceName}/get/expediente`,
  async ({ idLlamadoConcurso }, { dispatch }) => {
    const { data } = await axios.get(`${CONCURSOAPI}/llamadoconcurso/${idLlamadoConcurso}`);
    dispatch(getBoraFile({ idLlamadoConcurso }));
    return data;
  },
);

type GetBoraValues = { idLlamadoConcurso: number };
export const getBoraFile = createAsyncThunk<string, GetBoraValues>(
  `${sliceName}/get/file`,
  async ({ idLlamadoConcurso }) => {
    const { data } = await axios.get(
      `${CONCURSOAPI}/llamadoconcurso/files/bora/${idLlamadoConcurso}`,
      {
        responseType: 'blob',
      },
    );

    const file = new Blob([data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(file);

    return url;
  },
);

type PostActoVals = any;
export const postActoAdministrativo = createAsyncThunk(
  `${sliceName}/post`,
  async ({ idLlamadoConcurso, valores }: PostActoVals) => {
    const { expediente, ...etc } = valores;
    const formData = new FormData();
    formData.append('archivoBora', expediente);
    formData.append('datosActoAdministrativo', JSON.stringify(etc));
    await axios.post(
      `${CONCURSOAPI}/llamadoconcurso/actoadministrativo/${idLlamadoConcurso}`,
      formData,
    );
  },
);

const actoAdministrativoSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    cleanMsg: (state) => ({ ...state, success: '', error: '' }),
  },
  extraReducers: (builder) => {
    builder.addCase(getBoraFile.fulfilled, (state, action) => {
      state.file = action.payload;
      state.loading = false;
    });

    builder.addCase(getDatosExpediente.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });

    builder.addCase(postActoAdministrativo.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(postActoAdministrativo.fulfilled, (state) => {
      state.loading = false;
      state.success = 'Se cargó el acto administrativo y se derivo al Coordinador Concursal';
    });
  },
});

export const useActoAdministrativo = () =>
  useSelector((state: any) => state.actoAdministrativo) as State;

export const { cleanMsg } = actoAdministrativoSlice.actions;
const actoAdministrativo = actoAdministrativoSlice.reducer;
export default actoAdministrativo;
